import dynamic from 'next/dynamic';
import type { ChatHistorySignupCtaModalProps } from './ChatHistorySignupCtaModal-impl';

const ChatHistorySignupCtaModalImpl = dynamic(
  () =>
    import('./ChatHistorySignupCtaModal-impl').then(
      (mod) => mod.ChatHistorySignupCtaModalImpl
    ),
  { loading: () => null, ssr: false }
);

/**
 * Sign up CTA modal for viewing past chats when unauthenticated.
 * Shows the evidence signup CTA with banner and value propositions.
 */
export const ChatHistorySignupCtaModal = (props: ChatHistorySignupCtaModalProps) => {
  if (!props.isOpen || !props.portalContainer) return null;

  return <ChatHistorySignupCtaModalImpl {...props} />;
};
